module.exports = __webpack_public_path__ + "static/media/icon-sp.672cec6c.svg";